module.exports = __webpack_public_path__ + "img/7_81.2098b328.png";